// extracted by mini-css-extract-plugin
export default {"root":"CreateNewContactForm_root__nx5SN","checked":"CreateNewContactForm_checked__A876b","spin":"CreateNewContactForm_spin__EfroX"};